module.exports = __webpack_public_path__ + "static/img/title.c23f1d25.png";